import { render, staticRenderFns } from "./IconSvgFolder2.vue?vue&type=template&id=f8c56c76&scoped=true&"
import script from "./IconSvgFolder2.vue?vue&type=script&lang=js&"
export * from "./IconSvgFolder2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c56c76",
  null
  
)

export default component.exports